export default function PlusIcon() {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M11 11V3a1 1 0 012 0v8h8a1 1 0 010 2h-8v8a1 1 0 01-2 0v-8H3a1 1 0 010-2h8z" />
    </svg>
  );
}
